// extracted by mini-css-extract-plugin
export var indeterminate = "_1m-6";
export var md = "_1m-5";
export var semantic = "_1m-7";
export var sm = "_1m-4";
export var text = "_1m-8";
export var toggleControl = "_1m-0";
export var toggleInput = "_1m-1";
export var toggleSwitch = "_1m-2";
export var xs = "_1m-3";